import React, { useEffect } from 'react';
import { Button } from 'antd';
import { BoldOutlined, ItalicOutlined } from '@ant-design/icons';
import { BubbleMenu, EditorContent, useEditor } from '@tiptap/react';
import descriptionExtensions from './descriptionExtensions';
import DescriptionLinkButton from './DescriptionLinkButton';
import {
	DESCRIPTION_LIMIT,
	descriptionLength,
	isDescriptionTooBig,
	normalizeDescription,
} from './checklistDescription';

const DescriptionEditor = ({ value, onChange, label }) => {
	const editor = useEditor({
		extensions: descriptionExtensions,
		content: value,
		editorProps: { attributes: { role: 'textbox', 'aria-multiline': 'true', 'aria-label': label } },
		onUpdate: ({ editor: current }) => onChange(normalizeDescription(current.getHTML())),
	});

	// A reload replaces the draft under a mounted row, so sync when not typing.
	useEffect(() => {
		if (editor && !editor.isFocused && normalizeDescription(editor.getHTML()) !== value)
			editor.commands.setContent(value, false);
	}, [editor, value]);

	if (!editor) return null;
	const length = descriptionLength(value);
	const over = isDescriptionTooBig(value);

	return (
		<div className={`ChecklistEditor-description${editor.isEmpty ? ' is-empty' : ''}`}>
			<BubbleMenu editor={editor} className="ChecklistEditor-bubble">
				<Button
					type="text"
					size="small"
					icon={<BoldOutlined />}
					aria-label="Bold"
					onClick={() =>
						editor
							.chain()
							.focus()
							.toggleBold()
							.run()
					}
				/>
				<Button
					type="text"
					size="small"
					icon={<ItalicOutlined />}
					aria-label="Italic"
					onClick={() =>
						editor
							.chain()
							.focus()
							.toggleItalic()
							.run()
					}
				/>
				<DescriptionLinkButton editor={editor} />
			</BubbleMenu>
			<EditorContent editor={editor} />
			{editor.isEmpty && (
				<span className="ChecklistEditor-description-placeholder">
					Add a description (optional)
				</span>
			)}
			{(editor.isFocused || over) && (
				<span className={`ChecklistEditor-count${over ? ' is-over' : ''}`}>
					{length} / {DESCRIPTION_LIMIT}
				</span>
			)}
		</div>
	);
};

export default DescriptionEditor;
